import {filter, from, mergeMap, Observable, withLatestFrom} from "rxjs";
import { Action } from "@reduxjs/toolkit";
import {
  fileUploadError,
  fileUploadSuccess,
  nextStep,
  updateProgress,
  updateFileProgress,
  fileUploadStop
} from "../slices";
import {selectFailedFiles, selectFileStatuses, selectStoppedFiles, selectSuccessfulFiles} from "../selectors";

export const progressEpic = (
  action$: Observable<Action>,
  state$: Observable<any>
) => {
  return action$.pipe(
    filter(action => 
      fileUploadSuccess.match(action) || 
      fileUploadError.match(action) ||
      fileUploadStop.match(action) ||
      updateFileProgress.match(action)
    ),
    withLatestFrom(state$),
    mergeMap(([action, state]) => {

      const actions = [];
      
      const fileStatuses = selectFileStatuses(state);
      const allFiles = fileStatuses.length;
      const failed = selectFailedFiles(state).length;
      const success = selectSuccessfulFiles(state).length;
      const stopped = selectStoppedFiles(state).length;

      const totalProgress = fileStatuses.reduce((sum, file) => sum + file.progress, 0);
      let progress = allFiles > 0 ? Math.round(totalProgress / allFiles) : 0;

      if (success + failed + stopped === allFiles && allFiles > 0) {
        progress = 100;
        actions.push(nextStep());
      }

      actions.push(updateProgress(progress))

      return from(actions);
    })
  );
};
